import React from "react";
import { Box, Button, Text } from "@chakra-ui/react";

const MixtapeSelectedFiltersBar = ({
  selectedGenres = [],
  selectedSort = "",
  selectedFilter = "",
  filterOptions = [],
  onChange,
}) => {
  const labelFor = (v) => {
    const o = filterOptions.find((x) => x.value === v || x.text === v);
    return o?.label ?? o?.text ?? String(v);
  };
  const currentSort = selectedSort || "default";

  const clearGenre = (v) =>
    onChange({ name: "genres", values: selectedGenres.filter((x) => x !== v), altered: true });

  const clearAllGenres = () => onChange({ name: "genres", values: [], altered: true });

  const clearSort = () => onChange({ name: "sort", value: "default", altered: true });


  const clearFilter = () => onChange({ name: "filter", value: "", altered: true });

  const hasAny =
    (selectedGenres && selectedGenres.length > 0) ||
    currentSort !== "default" ||
    !!selectedFilter;

  if (!hasAny) return null;

  return (
    <div className="mixtape-selected-filters-bar">
      <Box mt="12px" display="flex" alignItems="center" gap="10px" mb="20px">
        <Text
          fontSize="12px"
          fontFamily="TTCommonsMedium"
          color="var(--purple)"
          mb="6px"
        >
          Filtered by:
        </Text>

        <Box display="flex" gap="8px" flexWrap="wrap">
          {/* Genres */}
          {selectedGenres.map((v) => (
            <Button
              key={`genre-${v}`}
              height="28px"
              px="12px"
              borderRadius="20px"
              variant="outline"
              border="1px solid var(--light-purple)"
              color="var(--purple)"
              onClick={() => clearGenre(v)}
            >
              <Text fontSize="12px" fontFamily="TTCommonsMedium">
                {labelFor(v)}
              </Text>
              <Box as="span" ml="8px" aria-hidden>
                ×
              </Box>
            </Button>
          ))}

          {/* Filter */}
          {selectedFilter && (
            <Button
              height="28px"
              px="12px"
              borderRadius="20px"
              variant="outline"
              border="1px solid var(--light-purple)"
              color="var(--purple)"
              onClick={clearFilter}
            >
              <Text fontSize="12px" fontFamily="TTCommonsMedium">
                Show: {labelFor(selectedFilter) || selectedFilter}
              </Text>
              <Box as="span" ml="8px" aria-hidden>
                ×
              </Box>
            </Button>
          )}

          {/* Sort */}
          {currentSort !== "default" && (
            <Button
              height="28px"
              px="12px"
              borderRadius="20px"
              variant="outline"
              border="1px solid var(--light-purple)"
              color="var(--purple)"
              onClick={clearSort}
            >
              <Text fontSize="12px" fontFamily="TTCommonsMedium">
                Sort: {currentSort.toUpperCase()}
              </Text>
              <Box as="span" ml="8px" aria-hidden>
                ×
              </Box>
            </Button>
          )}

          {(selectedGenres.length > 0 || currentSort !== "default" || !!selectedFilter) && (
            <Button
              height="28px"
              px="12px"
              variant="ghost"
              onClick={() =>
                onChange({
                 name: "clear_all",
                 values: [],      
                 sort: "default",  
                 filter: "",       
                 altered: true,
               })
             }
            >
              <Text fontSize="12px" fontFamily="TTCommonsMedium">
                Clear All
              </Text>
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default MixtapeSelectedFiltersBar;
